import React from "react"
import { BadgeButton } from "components-design-system"
import { getSchemaRegistryTitle } from "utilities/authoringFunctions.js"
import "./RegistryButtons.scss"

/**
 * @param {Object} props:
 *        * formView: determines the selected state
 *        * setFormView: changes selected state
 *        * registries: send specific registries
 *            For authoring view: limited # from URL params.
 *        * formSchemas: to get all section registries.
 *        * formSection: eg, {id: 'protocol', text: 'Protocol'}
 *            Used to get all registries and for button labels.
 * @returns JSX component
 */
const RegistryButtons = ({
  formView,
  setFormView,
  formSection,
  registries,
  formSchemas,
  showPagePreview,
  validationErrorsExist,
  clearValidations = () => {},
}) => {
  const onRegistryBtnClick = (regId) => {
    if (
      formSection &&
      formView &&
      // only if more than one button
      registries?.length > 1
    ) {
      const text = getSchemaRegistryTitle(formSection?.id, regId)
      let formViewObject = { id: regId, text }
      setFormView(formViewObject)
      clearValidations(null)
    }
  }

  const getValidationResults = (title) => {
    if (validationErrorsExist === true && title === formView.text.toUpperCase()) return "warning"
    else if (validationErrorsExist === false && title === formView.text.toUpperCase()) return "success"
    return null
  }

  if (formView && formSection) {
    if (!registries && formSection?.id && formSchemas) {
      registries = []
      const sectionSchemas = formSchemas[formSection.id].properties
      for (const regKey in sectionSchemas) {
        if (showPagePreview && regKey !== "global") registries.push(regKey)
        else if (!showPagePreview) registries.push(regKey)
      }
    }

    return (
      <div className="registry-buttons">
        {registries?.map((registry) => {
          const label = getSchemaRegistryTitle(formSection?.id, registry)
          return (
            <BadgeButton.RegistryFilter
              key={registry}
              registry={label}
              defaultFilterState={registry === formView?.id ? true : false}
              filterValue={registry === formView?.id ? true : false}
              onChangeFilter={() => onRegistryBtnClick(registry)}
              validateStatus={getValidationResults(label)}
            />
          )
        })}
      </div>
    )
  }

  return null
}

export default RegistryButtons
